import { QueryClientProvider } from '@tanstack/react-query';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { AuthProvider } from '@/context/auth-context';
import { queryClient } from '@/lib/query-client';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import NavigationShell from '@/components/layout/NavigationShell';
import DashboardPage from '@/pages/DashboardPage';
import LlmConfigPage from '@/pages/LlmConfigPage';
import WhatsAppConfigPage from '@/pages/WhatsAppConfigPage';
import DocumentsPage from '@/pages/DocumentsPage';
import DocumentDetailPage from '@/pages/DocumentDetailPage';
import MessagesPage from '@/pages/MessagesPage';
import LoginPage from '@/pages/LoginPage';
import { useAuth } from '@/hooks/use-auth';

function AppContent() {
  const { token } = useAuth();

  if (!token) {
    return <LoginPage />;
  }

  return <RouterProvider router={router} />;
}

const router = createBrowserRouter([
  {
    path: '/',
    element: <NavigationShell />,
    children: [
      { index: true, element: <DashboardPage /> },
      { path: 'llm-config', element: <LlmConfigPage /> },
      { path: 'whatsapp-config', element: <WhatsAppConfigPage /> },
      { path: 'documents', element: <DocumentsPage /> },
      { path: 'documents/:id', element: <DocumentDetailPage /> },
      { path: 'messages', element: <MessagesPage /> },
    ],
  },
], { basename: import.meta.env.BASE_URL });

function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <AppContent />
        </AuthProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

export default App;
